import { v4 as uuidv4 } from 'uuid'
import type { Callback, Notification, SnackbarProps } from './types'

let notifications: Notification[] = []
const subscribers: Set<Callback> = new Set()
const fadingTimeout = 240
const defaultTimeout = 2000

export const store = {
  read: () => notifications,

  subscribe: (callback: Callback) => {
    subscribers.add(callback)
    return () => subscribers.delete(callback)
  },

  show: (item: SnackbarProps & { timeout?: number }) => {
    const key = uuidv4()
    notifications = [...notifications, { ...item, id: key }]
    subscribers.forEach((callback) => callback())
    setTimeout(() => {
      store.delete(key)
    }, item.timeout || defaultTimeout)
  },

  delete: (idToRemove: string) => {
    const hasNotification = notifications.some(({ id }) => id === idToRemove)
    if (!hasNotification) {
      return
    }
    notifications = notifications.map((n) => ({ ...n, isFading: n.id === idToRemove }))
    subscribers.forEach((callback) => callback())

    setTimeout(() => {
      notifications = [...notifications.filter(({ id }) => id !== idToRemove)]
      subscribers.forEach((callback) => callback())
    }, fadingTimeout)
  },
}
